<div class="settings-page">
    <div class="settings-page__content">
        <div class="settings-card">
            <div class="settings-card__header">
                <img src="/assets/images/Group 24.svg" alt="" />
                <div class="settings-card__header-headline">
                    <h2>Bine ați venit!</h2>
                    <h4>Setările Dumneavoastră Direcția Generală de Asistență Socială și Protecția Copilului Sector 4
                    </h4>
                </div>
            </div>
        </div>
    </div>

    <div class="content-box">
        <div class="settings-page-container">
            <mat-button-toggle-group [value]="selectedComponent" (change)="onChange($event)" class="settings-page_menu">
                <mat-button-toggle [value]="option" class="settings-page_menu-item"
                    *ngFor="let option of componentKeys">
                    <div style="text-align: left;">
                        {{ option }}
                    </div>
                </mat-button-toggle>
            </mat-button-toggle-group>
        </div>
        <div class="settings-page__content">
            <ng-container *ngIf="selectedComponent === SettingsOption.GENERAL">
                <app-general></app-general>
            </ng-container>
            <ng-container *ngIf="selectedComponent === SettingsOption.PRIORITATE_CERERE">
                <app-cerere-priority></app-cerere-priority>
            </ng-container>
            <ng-container *ngIf="selectedComponent === SettingsOption.STATUS_CERERE">
                <app-status></app-status>
            </ng-container>
            <ng-container *ngIf="selectedComponent === SettingsOption.TIPURI_CERERE">
                <app-request-types></app-request-types>
            </ng-container>
            <ng-container *ngIf="selectedComponent === SettingsOption.SABLOANE_CERERE">
                <app-cerere-sabloane></app-cerere-sabloane>
            </ng-container>
            <ng-container *ngIf="selectedComponent === SettingsOption.CATEGORII_DOCUMENTE">
                <app-document-category></app-document-category>
            </ng-container>
            <ng-container *ngIf="selectedComponent === SettingsOption.TIPURI_DOCUMENTE">
                <app-document-type></app-document-type>
            </ng-container>
            <ng-container *ngIf="selectedComponent === SettingsOption.TEMPLATE_DOCUMENTE">
                <app-document-template></app-document-template>
            </ng-container>
            <ng-container *ngIf="selectedComponent === SettingsOption.CATEGORII_TEMPLATE">
                <app-template-categories></app-template-categories>
            </ng-container>
            <ng-container *ngIf="selectedComponent === SettingsOption.REGISTRE">
                <app-registre></app-registre>
            </ng-container>
            <ng-container *ngIf="selectedComponent === SettingsOption.OPERATORI">
                <app-operatori></app-operatori>
            </ng-container>
            <ng-container *ngIf="selectedComponent === SettingsOption.ZILE_LIBERE">
                <app-zile-libere></app-zile-libere>
            </ng-container>
            <ng-container *ngIf="selectedComponent === SettingsOption.PROGRAMARI_ACTIVITATI">
                <app-availability-management></app-availability-management>
            </ng-container>
            <ng-container *ngIf="selectedComponent === SettingsOption.MOTIVE_REFUZ">
                <app-motive-refuz></app-motive-refuz>
            </ng-container>
            <div class="row" *ngIf="selectedComponent == null">
                <div class="col-sm-12 py-5">
                    <div class="row h-100 justify-content-center align-items-center">
                        <div class="col-12 text-center">
                            <div class="py-3">
                                <p class="mb-0">Selectați o secțiune</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>